export default __webpack_public_path__ + "static/media/hero-one.7cb7537a.jpg";